export const DEFAULT_REQUISITION_DIMENSIONS = { width: '80vw', height: '90vh' };
